//====================================================
//  Function: Slider
//====================================================
function fn_components_slider(){
	fn_hero_slider();
	fn_testimonials_slider();
	fn_gallery_slider();
	fn_history_slider();
}

function fn_hero_slider(){
	if ($( '.js-slider-hero' ).length) {
		$( '.js-slider-hero' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 3000,
			fade: true,
			speed: 500,
			variableWidth: false,
			nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
			mobileFirst: true
		});
	}
}

function fn_testimonials_slider(){
	if ($( '.js-slider-testimonials' ).length) {
		$( '.js-slider-testimonials' ).slick({
			infinite: true,
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			autoplaySpeed: 3000,
			speed: 500,
			variableWidth: false,
			nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
			mobileFirst: true
		});
	}
}

function fn_history_slider(){
	if ($( '.js-slider-history' ).length) {
		$( '.js-slider-history' ).slick({
			infinite: false,
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			autoplaySpeed: 3000,
			speed: 500,
			variableWidth: true,
			nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 1220,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						variableWidth: true,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						variableWidth: true,
					}
				},
				{
					breakpoint: 770,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						variableWidth: false,
					}
				},
				{
					breakpoint: 560,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						variableWidth: false,
					}
				},
				{
					breakpoint: 460,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						variableWidth: false,
					}
				},
				{
					breakpoint: 200,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						variableWidth: false,
					}
				}
			]
		});
	}
}

function fn_gallery_slider(){
	if ($( '.js-slider-gallery-main' ).length) {
		$( '.js-slider-gallery-main' ).slick({
			infinite: false,
			dots: false,
			slidesToShow:1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			autoplaySpeed: 2000,
			speed: 500,
			nextArrow: '<span class="slick-arrows style-mobile slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
			prevArrow: '<span class="slick-arrows style-mobile slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
			variableWidth: false,
			mobileFirst: true
		});

		$( '.js-slider-gallery-main' ).on('afterChange', function(event, slick, currentSlide, nextSlide){
			$('.js-gallery-thumbnail figure').removeClass(class_active);
			$('.js-gallery-thumbnail figure').eq(currentSlide).addClass(class_active);
		});

		$(document).on('click', '.js-gallery-thumbnail figure' , function() {
			var thumbnailIndex = $(this).index();
			$( '.js-slider-gallery-main' ).slick('slickGoTo', thumbnailIndex);
		});
	}
}

